module.exports = __webpack_public_path__ + "img/maple-mask.9012e045.png";